import React, { useState, useEffect, useRef, useCallback } from 'react';

// Parse a CSS declaration string into a React style object.
// Kept minimal so we can paste style values verbatim from index.html.
function css(str) {
  const style = {};
  str.split(';').forEach((decl) => {
    if (!decl.trim()) return;
    const idx = decl.indexOf(':');
    if (idx === -1) return;
    const prop = decl.slice(0, idx).trim();
    const val = decl.slice(idx + 1).trim();
    const camel = prop.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
    style[camel] = val;
  });
  return style;
}

function Header() {
  return (
    <header style={css("background:#264631;border-bottom:1px solid rgba(239,236,221,0.22)")}>
      <div style={css("max-width:1320px;margin:0 auto;padding:16px clamp(22px,4vw,48px);display:flex;align-items:center;justify-content:space-between;gap:32px")}>
        <a href="#top" data-m="mark" data-testid="header-logo-link" style={css("display:flex;align-items:center")}>
          <img src="/assets/logo-cream-nobox.svg" alt="Full Court Advisory" style={css("height:36px;display:block;margin-top:5px")} />
        </a>
        <nav data-m="nav" style={css("display:flex;align-items:center;gap:30px;font-family:'Chivo',sans-serif;font-size:10.5px;letter-spacing:0.14em;text-transform:uppercase;color:#8ba694")}>
          <a href="#problem" data-testid="nav-problem" style={css("color:#8ba694")}>01 Problem</a>
          <a href="#why" data-testid="nav-why" style={css("color:#8ba694")}>02 Why Dave Ou</a>
          <a href="#voices" data-testid="nav-voices" style={css("color:#8ba694")}>03 Endorsements</a>
          <a href="#bring" data-testid="nav-bring" style={css("color:#8ba694")}>04 The work</a>
          <a href="#contact" data-testid="nav-contact" style={css("color:#f2efe0;border-bottom:2px solid #ffd02b;padding-bottom:2px")}>Discuss an opportunity</a>
        </nav>
      </div>
    </header>
  );
}

function HeroSection() {
  return (
    <section id="top" style={css("position:relative;background:#264631;color:#efecdd;border-bottom:1px solid #264631")}>
      <div style={css("position:relative;max-width:1320px;margin:0 auto;padding:0 clamp(22px,4vw,48px);display:grid;grid-template-columns:repeat(12,1fr)")} data-m="grid12">
        <div style={css("grid-column:1 / span 12;padding:26px 0 20px;font-family:'Chivo',sans-serif;font-size:10.5px;letter-spacing:0.26em;text-transform:uppercase;color:#8ba694;display:flex;justify-content:space-between")}>
          <span>Full Court Advisory</span>
        </div>
        <h1 data-m="h1" data-testid="hero-headline" style={css("grid-column:1 / span 11;margin:44px 0 0;font-size:clamp(42px,6.5vw,94px);line-height:1.06;font-weight:200;letter-spacing:-0.035em;color:#f4f1e2")}>
          For the opportunities that<br /><span style={css("font-weight:400;text-decoration:underline;text-decoration-color:#ffd02b;text-decoration-thickness:0.07em;text-underline-offset:0.12em")}>keep landing back</span> on the<br /><em style={css("font-weight:200")}>CEO{'\u2019'}s desk.</em>
        </h1>
        <div style={css("grid-column:1 / span 6;padding-right:32px;margin:56px 0 0")}>
          <p style={css("margin:0;font-size:20px;line-height:1.55;font-weight:300;color:#c2d0c3;text-wrap:pretty")}>Full Court takes on the opportunities that matter but <span style={css("color:#f4f1e2;font-weight:400")}>do not have a clear owner</span> inside the company.</p>
          <div style={css("margin-top:42px;display:flex")}>
            <a className="x1" href="#contact" data-m="herocta" data-testid="hero-cta" style={css("display:inline-flex;align-items:baseline;gap:12px;white-space:nowrap;color:#f4f1e2;text-decoration:none;font-size:clamp(20px,1.8vw,27px);font-weight:300;letter-spacing:-0.01em;line-height:1.1;padding:0 4px 10px;border-bottom:2px solid #ffd02b;background-image:linear-gradient(#ffd02b,#ffd02b);background-repeat:no-repeat;background-position:0 100%;background-size:100% 0;transition:background-size 260ms ease,border-bottom-width 260ms ease,color 260ms ease")}>Discuss an opportunity <span style={css("font-family:'Chivo',sans-serif;font-size:0.5em;position:relative;top:-0.15em")}>{'\u2192'}</span></a>
          </div>
        </div>
        <div data-m="fourwrap" style={css("grid-column:1 / span 12;margin-top:44px")}>
          <div data-m="fourlabel" style={css("font-family:'Chivo',sans-serif;font-size:10px;letter-spacing:0.26em;text-transform:uppercase;color:#8ba694;padding-bottom:14px")}>Where Full Court steps in</div>
          <div data-m="four" style={css("display:grid;grid-template-columns:repeat(4,1fr);border-top:1px solid rgba(239,236,221,0.45)")}>
            <div style={css("padding:18px 26px 18px 0")}><span style={css("font-size:clamp(20px,1.66vw,24.5px);font-weight:300;letter-spacing:-0.012em;line-height:1.25;color:#eae7d8")}>New ventures</span></div>
            <div style={css("padding:18px 26px 18px 26px;border-left:1px solid rgba(239,236,221,0.18)")}><span style={css("font-size:clamp(20px,1.66vw,24.5px);font-weight:300;letter-spacing:-0.012em;line-height:1.25;color:#eae7d8")}>Strategic partnerships</span></div>
            <div style={css("padding:18px 26px 18px 26px;border-left:1px solid rgba(239,236,221,0.18)")}><span style={css("font-size:clamp(20px,1.66vw,24.5px);font-weight:300;letter-spacing:-0.012em;line-height:1.25;color:#eae7d8")}>IP and talent commercialization</span></div>
            <div style={css("padding:18px 0 18px 26px;border-left:1px solid rgba(239,236,221,0.18)")}><span style={css("font-size:clamp(20px,1.66vw,24.5px);font-weight:300;letter-spacing:-0.012em;line-height:1.25;color:#eae7d8")}>Acquisitions &amp; investments</span></div>
          </div>
        </div>
        <div style={css("grid-column:1 / span 12;height:56px")}></div>
      </div>
    </section>
  );
}

function LogosSection() {
  return (
    <section style={css("position:relative;border-bottom:1px solid #264631")}>
      <div style={css("max-width:1320px;margin:0 auto;padding:clamp(34px,5vw,52px) clamp(22px,4vw,48px) clamp(36px,5vw,56px);display:flex;flex-direction:column;align-items:center;gap:34px")}>
        <div style={css("display:flex;flex-direction:column;align-items:center;gap:16px;max-width:760px")}>
          <h2 style={css("margin:0;font-size:clamp(26px,3.2vw,40px);line-height:1.1;font-weight:200;letter-spacing:-0.03em;color:#264631;text-align:center;text-wrap:balance")}>Experience behind Full Court</h2>
          <p style={css("margin:0;font-size:17.5px;line-height:1.7;font-weight:300;color:#40584a;text-align:center;text-wrap:pretty")}>My career has spanned strategy, M&amp;A, partnerships, business building, and emerging technology. It is the kind of cross-functional work that often ends up on a CEO{'\u2019'}s desk.</p>
        </div>
        <div data-m="logos3" style={css("display:grid;grid-template-columns:1fr auto 1fr;align-items:center;justify-items:center;column-gap:78px;row-gap:24px;width:100%;max-width:820px;opacity:0.9")}>
          <img src="/assets/logo-caa.png" alt="CAA" style={css("height:30px;width:auto;display:block")} />
          <img src="/assets/logo-ea.svg" alt="Electronic Arts" style={css("height:46px;width:auto;display:block")} />
          <img src="/assets/logo-baml.png" alt="Bank of America Merrill Lynch" style={css("height:44px;width:auto;display:block;transform:translateX(26px)")} />
        </div>
        <div data-m="logos3" style={css("display:grid;grid-template-columns:1fr auto 1fr;align-items:flex-start;justify-items:center;column-gap:72px;row-gap:30px;width:100%;max-width:920px")}>
          <div style={css("display:flex;flex-direction:column;align-items:center;gap:14px;max-width:260px")}>
            <div style={css("height:30px;display:flex;align-items:center;justify-content:center")}>
              <img src="/assets/logo-naver.png" alt="NAVER" style={css("height:19px;width:auto;display:block;opacity:0.9")} />
            </div>
            <div data-m="cap" style={css("font-size:12.5px;font-style:italic;line-height:1.4;color:#3d5a47;text-align:center")}>South Korea{'\u2019'}s largest internet company</div>
          </div>
          <div style={css("display:flex;flex-direction:column;align-items:center;gap:14px;max-width:260px")}>
            <div style={css("height:30px;display:flex;align-items:center;justify-content:center")}>
              <img src="/assets/logo-dust.png" alt="DUST" style={css("height:20px;width:auto;display:block;opacity:0.9")} />
            </div>
            <div data-m="cap" style={css("font-size:12.5px;font-style:italic;line-height:1.4;color:#3d5a47;text-align:center")}>Founded by Mark Cuban</div>
          </div>
          <div style={css("display:flex;flex-direction:column;align-items:center;gap:14px;max-width:300px")}>
            <div style={css("height:30px;display:flex;align-items:center;justify-content:center")}>
              <img src="/assets/logo-adim.png" alt="Adim" style={css("height:26px;width:auto;display:block;opacity:0.9;transform:translateY(-2px)")} />
            </div>
            <div data-m="cap" style={css("font-size:12.5px;font-style:italic;line-height:1.4;color:#3d5a47;text-align:center")}>Co-founded by Rob McElhenney {'\u00b7'} Backed by a16z crypto</div>
          </div>
        </div>
      </div>
    </section>
  );
}

function ProblemSection() {
  return (
    <section id="problem" style={css("position:relative;background:#264631;color:#efecdd;border-bottom:1px solid #264631")}>
      <div style={css("position:relative;max-width:1320px;margin:0 auto;padding:clamp(56px,8vw,96px) clamp(22px,4vw,48px);display:grid;grid-template-columns:repeat(12,1fr)")} data-m="grid12">
        <div data-m="side" style={css("grid-column:1 / span 2;padding-right:24px;position:sticky;top:32px;align-self:start")}>
          <div style={css("font-size:clamp(60px,7vw,104px);line-height:0.8;font-weight:200;color:rgba(239,236,221,0.26);letter-spacing:-0.04em")}>01</div>
          <div style={css("margin-top:20px;font-family:'Chivo',sans-serif;font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:#8ba694")}>The problem</div>
        </div>
        <h2 style={css("grid-column:3 / span 9;margin:0;font-size:clamp(32px,5vw,74px);line-height:1.02;font-weight:200;letter-spacing:-0.03em;color:#f4f1e2;text-wrap:balance")}>Important opportunities become <span style={css("font-weight:400;text-decoration:underline;text-decoration-color:#ffd02b;text-decoration-thickness:0.07em;text-underline-offset:0.12em")}>CEO jobs</span> by default.</h2>

        <div style={css("grid-column:3 / span 5;grid-row:3;padding-right:40px;margin-top:70px;font-size:18.5px;line-height:1.62;font-weight:300;color:#c2d0c3")}>
          <p style={css("margin:0;text-wrap:pretty")}>Every company has important opportunities that do not have an obvious owner. It could be a new market, a major partnership, a new business idea, or something else that falls outside the normal scope of the team. Because nobody is clearly responsible for it, it usually ends up with the CEO.</p>
        </div>
        <figure data-m="fig" style={css("grid-column:9 / span 4;grid-row:3;margin:70px 0 0;padding:26px 24px 20px;border:1px solid rgba(239,236,221,0.26)")}>
          <figcaption style={css("font-family:'Chivo',sans-serif;font-size:9.5px;letter-spacing:0.2em;text-transform:uppercase;color:#8ba694;margin-bottom:24px")}>Where the work routes</figcaption>
          <svg viewBox="0 0 420 250" style={css("width:100%;height:auto;display:block")} aria-label="Diagram: unowned threads converge on the CEO">
            <g fill="#9fb3a4" fontFamily="Chivo, sans-serif" fontSize="10.5" letterSpacing="0.08em">
              <text x="0" y="28">STRATEGY</text><text x="0" y="78">PRODUCT</text><text x="0" y="128">LEGAL</text><text x="0" y="178">FINANCE</text><text x="0" y="228">PARTNERS</text>
            </g>
            <g stroke="rgba(239,236,221,0.4)" strokeWidth="1" fill="none" strokeDasharray="3 4">
              <path d="M124 24 H240 Q272 24 272 60 V116" /><path d="M124 74 H252 Q272 74 272 100 V116" /><path d="M124 124 H272" /><path d="M124 174 H252 Q272 174 272 148 V132" /><path d="M124 224 H240 Q272 224 272 188 V132" />
            </g>
            <line x1="272" y1="124" x2="330" y2="124" stroke="#efecdd" strokeWidth="2" />
            <rect x="330" y="104" width="88" height="40" fill="#ffd02b" />
            <text x="374" y="129" textAnchor="middle" fill="#264631" fontFamily="Chivo, sans-serif" fontSize="13" fontWeight="600" letterSpacing="0.1em">CEO</text>
          </svg>
        </figure>

        <div style={css("grid-column:3 / span 9;grid-row:4;margin-top:88px;padding-top:44px;border-top:1px solid rgba(239,236,221,0.28)")}>
          <div style={css("width:52px;height:3px;background:#ffd02b;margin-bottom:26px")}></div>
          <p style={css("margin:0;font-size:clamp(28px,3.6vw,50px);line-height:1.14;font-weight:200;letter-spacing:-0.02em;color:#f2efe0;text-wrap:balance")}>Full Court takes it on so the CEO does not have to.</p>
        </div>
      </div>
    </section>
  );
}

function WhySection() {
  const sideSticky = css("position:sticky;top:32px");
  const splitRow = css("display:grid;grid-template-columns:1fr 3.4fr;gap:56px;align-items:start;padding:52px 0;border-top:1px solid #264631");
  const yellowBar = css("width:32px;height:5px;background:#ffd02b");
  const labRow = css("display:grid;grid-template-columns:150px 1fr;gap:32px;align-items:start");
  const labTag = css("padding-top:7px;border-top:1px solid rgba(38,70,49,0.28);font-variant:small-caps;font-size:16px;font-weight:400;letter-spacing:0.06em;color:#264631;line-height:1.35");
  const bodyText = css("display:flex;flex-direction:column;gap:34px;font-size:17.5px;line-height:1.7;font-weight:300;color:#40584a");
  const h3Style = css("margin:0 0 40px;font-size:29px;font-weight:400;line-height:1.16;text-wrap:pretty");
  const proseP = css("margin:0;text-wrap:pretty");
  const smallCap = css("font-variant:small-caps;letter-spacing:0.045em;color:#264631");

  return (
    <section id="why" style={css("position:relative;border-bottom:1px solid #264631")}>
      <div style={css("max-width:1320px;margin:0 auto;padding:clamp(56px,8vw,96px) clamp(22px,4vw,48px) 0;display:grid;grid-template-columns:repeat(12,1fr)")} data-m="grid12">
        <div data-m="side" style={css("grid-column:1 / span 2;padding-right:24px;position:sticky;top:32px;align-self:start")}>
          <div style={css("font-size:clamp(60px,7vw,104px);line-height:0.8;font-weight:200;color:rgba(38,70,49,0.22);letter-spacing:-0.04em")}>02</div>
          <div style={css("margin-top:20px;font-family:'Chivo',sans-serif;font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:#556B5C")}>Dave Ou</div>
        </div>
        <h2 style={css("grid-column:3 / span 9;margin:0;font-size:clamp(32px,5vw,74px);line-height:1.02;font-weight:200;letter-spacing:-0.03em;text-wrap:balance")}>Who you{'\u2019'}ll be <em style={css("font-weight:200")}>working with</em></h2>

        <div style={css("grid-column:3 / span 8;margin:64px 0 0;padding:40px 0 0;border-top:1px solid #264631")}>
          <p style={css("margin:0;font-size:clamp(20px,2.2vw,27px);line-height:1.44;font-weight:300;color:#40584a;text-wrap:pretty")}>{'I\u00a0'}started in tech and media M&amp;A on <span style={css("color:#264631;font-weight:400")}>Wall Street</span> before moving to <span style={css("color:#264631;font-weight:400")}>Electronic Arts</span>, where {'I\u00a0'}worked on corporate strategy and acquisitions during the rise of mobile and social gaming. {'I\u00a0'}later joined <span style={css("color:#264631;font-weight:400")}>CAA</span>, where {'I\u00a0'}built new businesses and worked across entertainment, technology, and venture investing. From there, {'I\u00a0'}moved into operating roles at venture-backed companies founded by <span style={css("color:#264631;font-weight:400")}>Mark Cuban</span> and <span style={css("color:#264631;font-weight:400")}>Rob McElhenney</span>.</p>
          <p style={css("margin:26px 0 0;font-size:clamp(20px,2.2vw,27px);line-height:1.44;font-weight:300;color:#40584a;text-wrap:pretty")}>In each of those environments, {'I\u00a0'}kept getting pulled into the same kind of work: <span style={css("color:#264631;text-decoration:underline;text-decoration-color:#ffd02b;text-decoration-thickness:0.07em;text-underline-offset:0.12em")}>figuring out whether an opportunity was worth pursuing</span> and then <span style={css("color:#264631;text-decoration:underline;text-decoration-color:#ffd02b;text-decoration-thickness:0.07em;text-underline-offset:0.12em")}>taking responsibility for moving it forward</span>. That is what Full Court is built on.</p>
        </div>
        <div style={css("grid-column:1 / span 12;height:76px")}></div>
      </div>

      <div style={css("max-width:1320px;margin:0 auto;padding:0 clamp(22px,4vw,48px) clamp(60px,8vw,100px)")}>

        <div data-m="split" style={splitRow}>
          <div style={sideSticky}>
            <div style={yellowBar}></div>
            <div style={css("margin-top:18px;font-size:clamp(24px,2.4vw,34px);line-height:1.06;font-weight:300;color:#264631;letter-spacing:-0.02em")}>University of Southern California</div>
          </div>
          <div>
            <div style={bodyText}>
              <div data-m="lab" style={labRow}>
                <div style={labTag}>Marshall School of Business</div>
                <p style={proseP}>Degree in accounting with an emphasis in finance.</p>
              </div>
            </div>
          </div>
        </div>

        <div data-m="split" style={splitRow}>
          <div style={sideSticky}>
            <div style={yellowBar}></div>
            <div style={css("margin-top:18px;font-size:clamp(38px,4vw,56px);line-height:0.9;font-weight:300;color:#264631;letter-spacing:-0.035em")}>$2B+</div>
            <div style={css("margin-top:14px;font-family:'Chivo',sans-serif;font-size:10px;letter-spacing:0.16em;text-transform:uppercase;color:#8a9a8e;line-height:1.7")}>in tech and media<br />M&amp;A transactions</div>
          </div>
          <div>
            <h3 style={h3Style}>M&amp;A and Corporate Strategy</h3>
            <div style={bodyText}>
              <div data-m="lab" style={labRow}>
                <div style={labTag}>Bear Stearns {'\u00b7'} Bank of America</div>
                <p style={proseP}>I spent my early career in tech and media mergers &amp; acquisitions at <span style={smallCap}>Bear Stearns</span> and <span style={smallCap}>Bank of America</span>, executing over $2 billion in buy-side and sell-side transactions.</p>
              </div>
              <div data-m="lab" style={labRow}>
                <div style={labTag}>Electronic Arts</div>
                <p style={proseP}>I then moved into corporate development at <span style={smallCap}>Electronic Arts</span>, where I identified strategic gaps and executed acquisitions, including Chillingo (publisher of Angry Birds and Cut the Rope), that helped establish EA as a major player in mobile gaming.</p>
              </div>
            </div>
          </div>
        </div>

        <div data-m="split" style={css("display:grid;grid-template-columns:1fr 3.4fr;gap:56px;align-items:start;padding:52px 0 52px 26px;border-top:1px solid #264631;border-left:3px solid #ffd02b")}>
          <div style={sideSticky}>
            <div style={yellowBar}></div>
            <div style={css("margin-top:18px;font-size:clamp(24px,2.4vw,34px);line-height:1.06;font-weight:300;color:#264631;letter-spacing:-0.02em")}>Created a new line of business for CAA and its clients</div>
          </div>
          <div>
            <h3 style={h3Style}>Building New Businesses and Closing Deals</h3>
            <div style={bodyText}>
              <div data-m="lab" style={labRow}>
                <div style={labTag}>The role</div>
                <p style={proseP}>At <span style={smallCap}>Creative Artists Agency</span> (CAA), I joined the Business Development group, where we built new businesses for the agency, invested in startups, and advised major technology and media companies.</p>
              </div>
              <div data-m="lab" style={labRow}>
                <div style={labTag}>Mobile games &amp; apps</div>
                <p style={proseP}>I created the agency{'\u2019'}s mobile games and apps division and built it into a new line of business, generating over eight figures in revenue for A-list talent across entertainment, music, and sports.</p>
              </div>
              <div data-m="lab" style={labRow}>
                <div style={labTag}>CAA Ventures</div>
                <p style={proseP}>As part of the five-person investment team at <span style={smallCap}>CAA Ventures</span>, a $20 million seed fund, I helped build a portfolio that included Giphy (acquired by Facebook), Meerkat (acquired by Epic Games), and Drone Racing League (acquired by Infinite Reality).</p>
              </div>
              <div data-m="lab" style={labRow}>
                <div style={labTag}>Corporate consulting</div>
                <p style={proseP}>Through CAA{'\u2019'}s Corporate Consulting arm, I signed and managed global technology and media companies representing seven figures in annual retainers, including leading the agency{'\u2019'}s engagement with LINE, a messaging platform with over 220 million users, on US market entry.</p>
              </div>
            </div>
          </div>
        </div>

        <div data-m="split" style={splitRow}>
          <div style={sideSticky}>
            <div style={yellowBar}></div>
            <div style={css("margin-top:18px;font-size:clamp(24px,2.4vw,34px);line-height:1.06;font-weight:300;color:#264631;letter-spacing:-0.02em")}>Built, operated, and turned around</div>
            <div style={css("margin-top:14px;font-family:'Chivo',sans-serif;font-size:10px;letter-spacing:0.16em;text-transform:uppercase;color:#8a9a8e;line-height:1.7")}>venture-backed<br />companies</div>
          </div>
          <div>
            <h3 style={h3Style}>Building and Operating Venture-Backed Companies</h3>
            <div style={bodyText}>
              <div data-m="lab" style={labRow}>
                <div style={labTag}>WAV Media</div>
                <p style={proseP}>At <span style={smallCap}>WAV Media</span>, backed by NAVER, I built out the company{'\u2019'}s partnerships from scratch, closed seven-figure deals, and helped raise $50 million in funding.</p>
              </div>
              <div data-m="lab" style={labRow}>
                <div style={labTag}>Radical App</div>
                <p style={proseP}>At <span style={smallCap}>Radical App</span>, Mark Cuban{'\u2019'}s venture studio, I served as COO across the portfolio, owned the P&amp;L, and led a turnaround of the Dust product that drove a 60% increase in organic downloads and tripled user retention.</p>
              </div>
              <div data-m="lab" style={labRow}>
                <div style={labTag}>Adim</div>
                <p style={proseP}>At <span style={smallCap}>Adim</span>, co-founded by Rob McElhenney and backed by a16z crypto, I led business development and strategy alongside the founders and ran the analysis behind major strategic decisions.</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

const ENDORSEMENTS = [
  { pre: "He has the unique ability to ", em: "execute complex corporate initiatives", post: " while also shepherding startups through early growth stages.", name: "Andrew Chan", role: "Vice President, Interactive at Fanatics Collectibles" },
  { pre: "He ", em: "treated the company like his own", post: ". He would always ask critical questions to further the projects and improve everyone\u2019s work.", name: "Jennifer Jo", role: "Chief Operating Officer, Open Ocean Games" },
  { pre: "His ability to ", em: "grind a problem down to its core", post: ", isolating what is truly important to the business and worthy of everyone\u2019s efforts.", name: "Ian R. Connelly", role: "Vice President of Product, Ricochet360" },
  { pre: "Dave is an incredible leader with deep knowledge of ", em: "building amazing teams and even better products", post: ". His work ethic is contagious and he continually brings out the best in all those around him.", name: "Evan \u201cNico\u201d Albert", role: "Engineering Manager at Meta" },
  { pre: "He demonstrated an ability to build and execute on strategies that ", em: "combined technology and entertainment", post: ", and he did this seamlessly.", name: "Dan Ferris", role: "Chief Strategy Officer and Co-Founder, rabbit inc" },
  { pre: "He has an amazing ability to ", em: "connect and work with executives", post: " and different domain experts. He applies his knowledge into actionable steps.", name: "Enok Kim", role: "Lead Product Manager, eyeo" },
  { pre: "Anywhere he goes he brings a ", em: "wealth of knowledge and relationships", post: " with him.", name: "Kyle Fiouzi", role: "App Growth Specialist" },
  { pre: "His start-up operations experience on top of his finance and business development background makes him a ", em: "triple threat", post: ".", name: "Sam Kokin", role: "Managing Partner, Sandwich Capital" },
];

function EndorsementsSection() {
  const trackRef = useRef(null);
  const [page, setPage] = useState(0);
  const [pages, setPages] = useState(1);
  const GAP = 28;
  const total = ENDORSEMENTS.length;

  const measure = useCallback(() => {
    const track = trackRef.current;
    if (!track) return;
    const card = track.firstElementChild;
    if (!card) return;
    const step = card.getBoundingClientRect().width + GAP;
    const per = Math.max(1, Math.round((track.clientWidth + GAP) / step));
    const newPages = Math.max(1, Math.ceil(total / per));
    setPages(newPages);
    setPage(Math.min(Math.round(track.scrollLeft / (track.clientWidth + GAP)), newPages - 1));
  }, [total]);

  const go = (p) => {
    const track = trackRef.current;
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth;
    const target = Math.max(0, Math.min(max, p * (track.clientWidth + GAP)));
    // Direct assignment, not scrollTo({behavior:'smooth'}). Animated scrolling is
    // unreliable inside a scroll-snap container. Snap settles the landing.
    track.scrollLeft = target;
    requestAnimationFrame(measure);
  };

  useEffect(() => {
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [measure]);

  const onKeyDown = (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(page + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(page - 1); }
  };

  const cardStyle = css("flex:0 0 calc((100% - 56px) / 3);margin:0;display:flex;flex-direction:column;justify-content:space-between;gap:26px;scroll-snap-align:start;padding-top:22px;border-top:1px solid rgba(239,236,221,0.32)");
  const quoteStyle = css("margin:0;font-size:19px;line-height:1.55;font-weight:300;color:#cdd8cf;text-wrap:pretty");
  const emStyle = css("color:#f4f1e2;font-weight:400");
  const nameStyle = css("font-family:'Chivo',sans-serif;font-size:11px;letter-spacing:0.16em;text-transform:uppercase;color:#f2efe0;line-height:1.4");
  const titleStyle = css("margin-top:8px;font-size:15px;line-height:1.45;font-weight:300;color:#9fb3a4;text-wrap:pretty");
  const arrowStyle = css("width:48px;height:48px;display:flex;align-items:center;justify-content:center;background:transparent;border:1px solid rgba(239,236,221,0.4);color:#f2efe0;font-size:17px;line-height:1;cursor:pointer");

  return (
    <section id="voices" style={css("position:relative;border-top:3px solid #ffd02b")}>
      <div style={css("max-width:1320px;margin:0 auto;padding:clamp(52px,7vw,88px) clamp(22px,4vw,48px) clamp(56px,7vw,92px);display:grid;grid-template-columns:repeat(12,1fr)")} data-m="grid12">
        <div data-m="side" style={css("grid-column:1 / span 2;padding-right:24px;position:sticky;top:32px;align-self:start")}>
          <div style={css("font-size:clamp(60px,7vw,104px);line-height:0.8;font-weight:200;color:rgba(38,70,49,0.22);letter-spacing:-0.04em")}>03</div>
          <div style={css("margin-top:20px;font-family:'Chivo',sans-serif;font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:#556B5C")}>Endorsements</div>
        </div>
        <h2 style={css("grid-column:3 / span 9;margin:0;font-size:clamp(30px,4.4vw,64px);line-height:1.04;font-weight:200;letter-spacing:-0.03em;color:#264631;text-wrap:balance")}>I would rather <span style={css("font-weight:400;text-decoration:underline;text-decoration-color:#ffd02b;text-decoration-thickness:0.07em;text-underline-offset:0.12em")}>they told you</span>.</h2>

        <div style={css("grid-column:1 / span 12;min-width:0;margin-top:clamp(34px,4vw,52px);background:#264631;color:#efecdd;padding:clamp(30px,3.6vw,48px) clamp(24px,3.2vw,44px) clamp(24px,2.6vw,34px)")}>
          <div ref={trackRef} data-m="qtrack" tabIndex={0} role="group" aria-label="Endorsements, use arrow keys to browse" onKeyDown={onKeyDown} onScroll={measure} style={css("display:flex;gap:28px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;padding-bottom:6px;outline:none")}>
            {ENDORSEMENTS.map((q, i) => (
              <figure key={i} data-m="qcard" style={cardStyle}>
                <blockquote data-m="qtext" style={quoteStyle}>{'\u201c'}{q.pre}<span style={emStyle}>{q.em}</span>{q.post}{'\u201d'}</blockquote>
                <figcaption>
                  <div style={nameStyle}>{q.name}</div>
                  <div style={titleStyle}>{q.role}</div>
                </figcaption>
              </figure>
            ))}
          </div>
          <div style={css("margin-top:clamp(26px,3vw,38px);display:flex;align-items:center;gap:clamp(20px,3vw,40px)")}>
            <div id="q-dots" style={css("flex:1;display:flex;align-items:center;gap:10px")}>
              {Array.from({ length: pages }).map((_, i) => (
                <button key={i} type="button" aria-label={`Endorsements page ${i + 1} of ${pages}`} onClick={() => go(i)} style={{ flex: '0 0 46px', height: '2px', padding: 0, margin: 0, border: 'none', cursor: 'pointer', background: i === page ? '#ffd02b' : 'rgba(239,236,221,0.22)' }} />
              ))}
            </div>
            <div style={css("display:flex;gap:12px")}>
              <button type="button" data-q="prev" disabled={page <= 0} aria-label="Previous endorsements" onClick={() => go(page - 1)} style={arrowStyle}>{'\u2190'}</button>
              <button type="button" data-q="next" disabled={page >= pages - 1} aria-label="More endorsements" onClick={() => go(page + 1)} style={arrowStyle}>{'\u2192'}</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function BringSection() {
  const rowStyle = css("display:grid;grid-template-columns:1fr 3fr 4fr;align-items:start;padding:34px 0;border-top:1px solid rgba(239,236,221,0.24)");
  const rowStyleFirst = css("display:grid;grid-template-columns:1fr 3fr 4fr;align-items:start;padding:34px 0;border-top:1px solid rgba(239,236,221,0.55)");
  const rowStyleLast = css("display:grid;grid-template-columns:1fr 3fr 4fr;align-items:start;padding:34px 0 40px;border-top:1px solid rgba(239,236,221,0.24);border-bottom:1px solid rgba(239,236,221,0.55)");
  const num = css("font-size:54px;line-height:0.82;font-weight:200;color:#e8a97a;padding-right:24px");
  const h3 = css("font-size:26px;font-weight:400;line-height:1.16;margin:0;padding-right:40px;color:#f2efe0;text-wrap:pretty");
  const p = css("margin:0;font-size:17.5px;line-height:1.62;font-weight:300;color:#c2d0c3;text-wrap:pretty");

  return (
    <section id="bring" style={css("position:relative;background:#264631;color:#efecdd;border-bottom:1px solid #264631")}>
      <div style={css("position:relative;max-width:1320px;margin:0 auto;padding:clamp(56px,8vw,96px) clamp(22px,4vw,48px) clamp(60px,8vw,100px);display:grid;grid-template-columns:repeat(12,1fr)")} data-m="grid12">
        <div data-m="side" style={css("grid-column:1 / span 2;padding-right:24px;position:sticky;top:32px;align-self:start")}>
          <div style={css("font-size:clamp(60px,7vw,104px);line-height:0.8;font-weight:200;color:rgba(239,236,221,0.26);letter-spacing:-0.04em")}>04</div>
          <div style={css("margin-top:20px;font-family:'Chivo',sans-serif;font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:#8ba694")}>The work</div>
        </div>
        <h2 style={css("grid-column:3 / span 9;margin:0;font-size:clamp(32px,5vw,74px);line-height:1.02;font-weight:200;letter-spacing:-0.03em;color:#f4f1e2;text-wrap:balance")}>Bring in Full Court when the next move needs a <span style={css("font-weight:400;text-decoration:underline;text-decoration-color:#ffd02b;text-decoration-thickness:0.07em;text-underline-offset:0.12em")}>senior owner</span>.</h2>

        <div style={css("grid-column:1 / span 12;margin-top:80px")}>
          <div data-m="row3" style={rowStyleFirst}>
            <div style={num}>I</div>
            <h3 style={h3}>New Ventures</h3>
            <p style={p}>The company has an opportunity to launch a new vertical, product line, or market but nobody is driving it. It needs someone to determine whether it is worth pursuing and lead it if it is.</p>
          </div>
          <div data-m="row3" style={rowStyle}>
            <div style={num}>II</div>
            <h3 style={h3}>Strategic Partnerships</h3>
            <p style={p}>A partnership, distribution deal, or commercial relationship could meaningfully change the business but it needs to be developed, structured, and negotiated across multiple internal and external stakeholders.</p>
          </div>
          <div data-m="row3" style={rowStyle}>
            <div style={num}>III</div>
            <h3 style={h3}>IP and Talent Commercialization</h3>
            <p style={p}>There is valuable IP, talent, or an audience that could become a significant business, but the model, the partners, and the path to market have not been worked out.</p>
          </div>
          <div data-m="row3" style={rowStyleLast}>
            <div style={num}>IV</div>
            <h3 style={h3}>Acquisitions &amp; Investments</h3>
            <p style={p}>A potential acquisition, investment, or strategic transaction needs to be evaluated, structured, and driven to a decision.</p>
          </div>
        </div>

      </div>
    </section>
  );
}

const initialForm = { name: '', company: '', website: '', email: '', opportunity: '', phone: '' };

function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [pending, setPending] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState(initialForm);

  const inputBase = css("width:100%;box-sizing:border-box;background:rgba(38,70,49,0.05);border-width:1px;border-style:solid;border-color:rgba(38,70,49,0.3);color:#264631;font-family:'Newsreader',serif;font-size:18px;line-height:1.5;padding:13px 14px;outline:none;border-radius:0;transition:border-color 180ms ease,background 180ms ease");
  const inputError = { ...inputBase, borderColor: '#c97a4a', background: 'rgba(201,122,74,0.06)' };
  const textareaStyle = { ...inputBase, resize: 'none', display: 'block' };
  const textareaError = { ...textareaStyle, borderColor: '#c97a4a', background: 'rgba(201,122,74,0.06)' };
  const labelSpan = css("font-family:'Chivo',sans-serif;font-size:10px;font-weight:500;letter-spacing:0.16em;text-transform:uppercase;color:#556B5C;display:block;margin-bottom:9px");
  const fieldError = css("margin:8px 0 0;font-family:'Chivo',sans-serif;font-size:10.5px;letter-spacing:0.12em;text-transform:uppercase;color:#c97a4a;line-height:1.5");
  const honeypotStyle = { position: 'absolute', left: '-9999px', top: 'auto', width: '1px', height: '1px', overflow: 'hidden', opacity: 0 };

  const validEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
  const validWebsite = (w) => /^[^\s.]+\.[^\s.]+/.test(w.trim());

  const setField = (key, value) => {
    setForm((f) => ({ ...f, [key]: value }));
    if (errors[key] || errors._form) {
      setErrors((prev) => {
        const next = { ...prev, [key]: '' };
        delete next._form;
        return next;
      });
    }
  };

  const validate = () => {
    const next = {};
    if (!form.name.trim()) next.name = 'Please add your full name.';
    if (!form.company.trim()) next.company = 'Please add your company.';
    if (!validWebsite(form.website)) next.website = 'Please add your company website.';
    if (!validEmail(form.email.trim())) next.email = 'Please enter a valid email address.';
    if (!form.opportunity.trim()) next.opportunity = 'Please describe the opportunity.';
    return next;
  };

  const onSubmit = async (e) => {
    if (e) e.preventDefault();
    const v = validate();
    if (Object.keys(v).length > 0) {
      setErrors(v);
      const first = ['name', 'company', 'website', 'email', 'opportunity'].find((k) => v[k]);
      if (first) {
        const el = document.querySelector(`[data-field="${first}"]`);
        if (el && el.focus) el.focus();
      }
      return;
    }
    setErrors({});
    setPending(true);
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/contact`;
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name.trim(),
          company: form.company.trim(),
          website: form.website.trim(),
          email: form.email.trim(),
          opportunity: form.opportunity.trim(),
          phone: form.phone,
        }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.detail || 'Something went wrong. Please try again.');
      }
      setSubmitted(true);
    } catch (err) {
      setErrors({ _form: err.message || 'Something went wrong. Please try again.' });
    } finally {
      setPending(false);
    }
  };

  const onKeyDown = (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') onSubmit(e);
  };

  const reset = () => {
    setForm(initialForm);
    setErrors({});
    setSubmitted(false);
    setTimeout(() => {
      const el = document.querySelector('[data-field="name"]');
      if (el && el.focus) el.focus();
    }, 30);
  };

  return (
    <section id="contact" style={css("position:relative;background:#efecdd;color:#264631")}>
      <div style={css("position:relative;max-width:1320px;margin:0 auto;padding:clamp(56px,8vw,96px) clamp(22px,4vw,48px) clamp(60px,8vw,100px);display:grid;grid-template-columns:repeat(12,1fr);row-gap:0")} data-m="grid12">
        <div data-m="side" style={css("grid-column:1 / span 2;padding-right:24px;position:sticky;top:32px;align-self:start")}>
          <div style={css("font-size:clamp(60px,7vw,104px);line-height:0.8;font-weight:200;color:rgba(38,70,49,0.22);letter-spacing:-0.04em")}>05</div>
          <div style={css("margin-top:20px;font-family:'Chivo',sans-serif;font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:#556B5C")}>Start a conversation</div>
        </div>
        <h2 style={css("grid-column:3 / span 9;margin:0;padding-right:40px;font-size:clamp(36px,5vw,74px);line-height:1.02;font-weight:200;letter-spacing:-0.03em;text-wrap:balance")}>Tell me what <span style={css("font-weight:400;text-decoration:underline;text-decoration-color:#ffd02b;text-decoration-thickness:0.07em;text-underline-offset:0.12em")}>keeps landing back</span> on your desk.</h2>

        <p style={css("grid-column:3 / span 8;margin:44px 0 0;padding-right:40px;font-size:clamp(22px,2vw,26px);line-height:1.5;font-weight:300;color:#3d5a47;text-wrap:pretty")}>It does not need to be fully defined. A clear opportunity and an open question are both good places to start.</p>

        <div style={css("grid-column:3 / span 10;margin-top:64px")}>
          {submitted ? (
            <div data-testid="contact-success" style={css("padding:52px 44px;border:1px solid rgba(38,70,49,0.3);background:rgba(255,208,43,0.08);display:flex;flex-direction:column;align-items:flex-start")}>
              <div aria-hidden="true" style={css("display:flex;align-items:center;justify-content:center;width:56px;height:56px;background:#ffd02b;color:#264631;font-family:'Chivo',sans-serif;font-size:26px;font-weight:600;line-height:1")}>{'\u2713'}</div>
              <h3 style={css("margin:26px 0 0;font-family:'Newsreader',serif;font-size:clamp(32px,3.4vw,44px);font-weight:300;line-height:1.05;letter-spacing:-0.02em;color:#264631;text-wrap:balance")}>Thank you.</h3>
              <p style={css("margin:18px 0 0;max-width:560px;font-size:18px;line-height:1.55;font-weight:300;color:#3d5a47;text-wrap:pretty")}>Your note is on its way. Dave will be in touch shortly, usually within one business day.</p>
              <div style={css("margin-top:34px;padding-top:22px;border-top:1px solid rgba(38,70,49,0.25);width:100%")}>
                <button type="button" onClick={reset} data-testid="send-another" style={css("background:transparent;border:none;padding:0;cursor:pointer;font-family:'Chivo',sans-serif;font-size:11px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:#264631;border-bottom:2px solid #ffd02b;padding-bottom:3px;transition:color 200ms ease")}>Send another message {'\u2192'}</button>
              </div>
            </div>
          ) : (
            <form id="fca-form" data-testid="contact-form" onSubmit={onSubmit} onKeyDown={onKeyDown} noValidate style={css("display:flex;flex-direction:column;gap:22px")}>
              <div data-m="fields4" style={css("display:grid;grid-template-columns:repeat(4,1fr);gap:22px")}>
                <label style={css("display:block")}>
                  <span style={labelSpan}>Full name</span>
                  <input className="x3" type="text" data-testid="input-name" data-field="name" autoComplete="name" value={form.name} onChange={(e) => setField('name', e.target.value)} aria-invalid={!!errors.name} style={errors.name ? inputError : inputBase} />
                  {errors.name && <div data-testid="error-name" style={fieldError}>{errors.name}</div>}
                </label>
                <label style={css("display:block")}>
                  <span style={labelSpan}>Company</span>
                  <input className="x4" type="text" data-testid="input-company" data-field="company" autoComplete="organization" value={form.company} onChange={(e) => setField('company', e.target.value)} aria-invalid={!!errors.company} style={errors.company ? inputError : inputBase} />
                  {errors.company && <div data-testid="error-company" style={fieldError}>{errors.company}</div>}
                </label>
                <label style={css("display:block")}>
                  <span style={labelSpan}>Company website</span>
                  <input className="x4" type="text" data-testid="input-website" data-field="website" autoComplete="url" placeholder="acme.com" value={form.website} onChange={(e) => setField('website', e.target.value)} aria-invalid={!!errors.website} style={errors.website ? inputError : inputBase} />
                  {errors.website && <div data-testid="error-website" style={fieldError}>{errors.website}</div>}
                </label>
                <label style={css("display:block")}>
                  <span style={labelSpan}>Email</span>
                  <input className="x5" type="email" data-testid="input-email" data-field="email" autoComplete="email" inputMode="email" value={form.email} onChange={(e) => setField('email', e.target.value)} aria-invalid={!!errors.email} style={errors.email ? inputError : inputBase} />
                  {errors.email && <div data-testid="error-email" style={fieldError}>{errors.email}</div>}
                </label>
              </div>
              <label style={css("display:block")}>
                <span style={labelSpan}>The opportunity</span>
                <textarea className="x6" rows="6" data-testid="input-opportunity" data-field="opportunity" value={form.opportunity} onChange={(e) => setField('opportunity', e.target.value)} aria-invalid={!!errors.opportunity} style={errors.opportunity ? textareaError : textareaStyle}></textarea>
                {errors.opportunity && <div data-testid="error-opportunity" style={fieldError}>{errors.opportunity}</div>}
              </label>
              <div aria-hidden="true" style={honeypotStyle}>
                <label>
                  Phone number (leave this blank)
                  <input type="text" name="phone" tabIndex={-1} autoComplete="off" value={form.phone} onChange={(e) => setField('phone', e.target.value)} />
                </label>
              </div>
              {errors._form && (
                <div data-testid="form-error" style={css("font-family:'Chivo',sans-serif;font-size:11.5px;letter-spacing:0.12em;text-transform:uppercase;color:#c97a4a;border-top:1px solid rgba(201,122,74,0.5);padding-top:12px;line-height:1.5")}>{errors._form}</div>
              )}
              <button className="x2" type="submit" data-testid="submit-button" disabled={pending} aria-busy={pending} style={{ ...css("margin-top:14px;width:100%;box-sizing:border-box;display:flex;align-items:center;justify-content:space-between;gap:20px;background:#264631;color:#f4f1e2;border:1px solid #264631;font-family:'Chivo',sans-serif;font-size:12.5px;font-weight:600;letter-spacing:0.14em;text-transform:uppercase;padding:21px 26px;cursor:pointer;transition:background 200ms ease,color 200ms ease,opacity 200ms ease"), opacity: pending ? 0.7 : 1 }}>
                <span data-testid="submit-label">{pending ? 'Sending\u2026' : 'Send'}</span>
                <span style={css("font-size:16px;line-height:1")}>{'\u2192'}</span>
              </button>
              <p style={css("margin:6px 0 0;font-family:'Chivo',sans-serif;font-size:10px;letter-spacing:0.12em;text-transform:uppercase;color:#8a9a8e;line-height:1.6")}>Replies come directly from Dave, never a form response.</p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer style={css("background:#264631;border-top:1px solid rgba(239,236,221,0.24)")}>
      <div style={css("max-width:1320px;margin:0 auto;padding:clamp(38px,5vw,56px) clamp(22px,4vw,48px) clamp(34px,4vw,48px);display:flex;align-items:flex-end;justify-content:space-between;gap:48px;flex-wrap:wrap")}>
        <img src="/assets/logo-cream-nobox.svg" alt="Full Court Advisory" style={css("height:64px;display:block")} />
        <div style={css("font-family:'Chivo',sans-serif;font-size:11px;letter-spacing:0.06em;color:#8ba694;text-align:right;line-height:1.9")}>
          <div>hello@fullcourtadvisory.com</div>
          <div>{'\u00a9'} 2026 Full Court Advisory</div>
        </div>
      </div>
    </footer>
  );
}

export default function App() {
  return (
    <div style={css("background:#efecdd;font-family:'Newsreader',Georgia,serif;color:#264631")}>
      <Header />
      <HeroSection />
      <LogosSection />
      <ProblemSection />
      <WhySection />
      <EndorsementsSection />
      <BringSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
